export class ProtobufSchemaParser {
  constructor() {
    this.messages = new Map();
    this.currentMessage = null;
  }

  parseSchema(schemaText) {
    this.messages.clear();
    this.currentMessage = null;

    const lines = schemaText.split('\n');
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      if (!line) continue;

      let cleanLine = line;
      const commentIndex = line.indexOf('//');
      if (commentIndex !== -1) {
        cleanLine = line.substring(0, commentIndex).trim();
        if (!cleanLine) continue;
      }

      if (cleanLine.startsWith('syntax =') || 
          cleanLine.startsWith('package ') || 
          cleanLine.startsWith('import ') ||
          cleanLine.startsWith('option ')) {
        continue;
      }

      const messageMatch = cleanLine.match(/^message\s+(\w+)\s*\{$/);
      if (messageMatch) {
        this.currentMessage = {
          name: messageMatch[1],
          fields: [],
          startLine: i
        };
        console.log(`Found message: ${messageMatch[1]}`);
        continue;
      }

      if (cleanLine === '}' && this.currentMessage) {
        this.messages.set(this.currentMessage.name, this.currentMessage);
        console.log(`Completed message: ${this.currentMessage.name} with ${this.currentMessage.fields.length} fields`);
        this.currentMessage = null;
        continue;
      }

      if (this.currentMessage) {
        const optionalMatch = cleanLine.match(/^optional\s+(\w+)\s+(\w+)\s*=\s*(\d+)\s*;?\s*$/);
        if (optionalMatch) {
          const [, type, name, number] = optionalMatch;
          this.currentMessage.fields.push({
            type: type.toLowerCase(),
            name,
            number: parseInt(number),
            repeated: false,
            optional: true
          });
          console.log(`Found optional field: ${type} ${name} = ${number}`);
        } else {
          const fieldMatch = cleanLine.match(/^(\w+)\s+(\w+)\s*=\s*(\d+)\s*;?\s*$/);
          if (fieldMatch) {
            const [, type, name, number] = fieldMatch;
            this.currentMessage.fields.push({
              type: type.toLowerCase(),
              name,
              number: parseInt(number),
              repeated: false,
              optional: false
            });
            console.log(`Found field: ${type} ${name} = ${number}`);
          } else {
            const repeatedMatch = cleanLine.match(/^repeated\s+(\w+)\s+(\w+)\s*=\s*(\d+)\s*;?\s*$/);
            if (repeatedMatch) {
              const [, type, name, number] = repeatedMatch;
              this.currentMessage.fields.push({
                type: type.toLowerCase(),
                name,
                number: parseInt(number),
                repeated: true,
                optional: false
              });
              console.log(`Found repeated field: ${type} ${name} = ${number}`);
            }
          }
        }
      }
    }

    console.log(`Total messages parsed: ${this.messages.size}`);
    return this.messages;
  }

  getFieldByNumber(messageName, fieldNumber) {
    const message = this.messages.get(messageName);
    if (!message) return null;
    
    return message.fields.find(field => field.number === fieldNumber);
  }

  getMessageNames() {
    return Array.from(this.messages.keys());
  }

  getMessageFields(messageName) {
    const message = this.messages.get(messageName);
    return message ? message.fields : [];
  }

  validateSchema(schemaText) {
    try {
      const messages = this.parseSchema(schemaText);
      const errors = [];

      if (messages.size === 0) {
        errors.push('No message definitions found');
      }

      for (const [messageName, message] of messages) {
        if (message.fields.length === 0) {
          continue;
        }

        const fieldNumbers = message.fields.map(f => f.number);
        const uniqueNumbers = new Set(fieldNumbers);
        if (fieldNumbers.length !== uniqueNumbers.size) {
          errors.push(`Message '${messageName}' has duplicate field numbers`);
        }
      }

      return {
        valid: errors.length === 0,
        errors
      };
    } catch (error) {
      return {
        valid: false,
        errors: [error.message]
      };
    }
  }
} 